$(document).ready(function() {
    var apiCalls = $('input[data-api]');
    var nonce = $('body').data('rest-nonce');
    var overlay = $('#textblock-confirm');

    apiCalls.each(function (i, caller) {
        var apiInput = $(caller);
        if (apiInput && apiInput.length) {
            var fieldid = apiInput.data('fieldid');
            var url = apiInput.data('api');
            var textarea = $('#' + fieldid + ' textarea');
            url = url.replace("#fieldid#", fieldid);

            var btnText = overlay.data('btn-title');

            textarea.prop('readonly', true);
            textarea.after('<div data-url="' + url + '" data-fieldid="' + fieldid + '" class="textarea-chooser"><a href="" class="stretched-link"></a><button type="button" class="mxm_button btn btn-outline-primary">' + btnText + ' <i class="fas fa-circle-notch fa-spin"></i></button></div>');
        }
    });

    var box;
    var $item;
    var user;
    var application;
    var notes;
    var users;

    function initNotes() {
        var textHtml = "";

        $.each(notes, function (i, el) {
            textHtml += '<div class="note row">';
            textHtml += '<div class="col-12"><label>User ' + el.author + '</label> <label class="date">'+el.date+'</label></div>';
            textHtml += '<div class="col-12"><p>' + el.text + '</p></div>';
            textHtml += '</div>';
        });
        var d = new Date;
        var inputHtml = "";
        inputHtml += '<div class="note new row">';
        inputHtml += '<div class="col-12"><label>Neue Notiz</label> <label class="date">' + d.getDate() + ". " + (d.getMonth() + 1) + ". " + d.getFullYear() + "</label></div>";
        inputHtml += '<div class="col-9"><textarea></textarea></div>';
        inputHtml += '<div class="col-3"><button class="note-save btn-green" data-user="' + user + '" data-app="' + application + '"> Speichern</div>';
        inputHtml += "</div>";
        box = $.confirm({
            columnClass: 'large',
            title: overlay.data('fc-title'),
            content: '<div class="notes container-fluid">' + textHtml + inputHtml + '</div>',
            buttons: {
                cancel: {
                    text: overlay.data('fc-no'),
                    btnClass: 'btn-red',
                    action: function(){
                    }
                }
            }
        });
    }

    function openNotes()
    {
        $item.prop('disabled', true);
        $.ajax({
            type: 'GET',
            url: '/wp-json/mxm_angebote/getNotes',
            data: {
                user: user,
                application: application
            },
            beforeSend: function (xhr) {
                $item.addClass('loading');
                if (nonce && nonce.length) {
                    xhr.setRequestHeader('X-WP-Nonce', nonce);
                }
            }
        }).done(function (result) {
            console.log("RES");
            console.log(result);
            notes = result.notes;
            initNotes();
        }).fail(function (result) {
            console.warn(result);
        }).always(function () {
            $item.removeClass('loading');
            $item.prop('disabled', false);
        });
    }

    $('a.notes').on('click', function (event) {
        event.preventDefault();
        $item = $(this);
        user = $item.data('user');
        application = $item.data('application');
        console.log("Notes Click");
        openNotes();        
    });

    $("body").on("click", "button.note-save", (function (e) {
        console.log("saving");
        var $button = $(this);
        $button.prop('disabled', true);
        var user = $button .data("user");
        var application = $button.data("app");
        console.log("user", user);
        console.log("application", application);
        $.ajax({
            type: "POST",
            url: "/wp-json/mxm_angebote/addnote",
            data: {
                user: user,
                application: application,
                text: $(".note.new textarea").val()
            },
            beforeSend: function (xhr) {
                $button.addClass("loading");
                if (nonce && nonce.length) {
                    xhr.setRequestHeader('X-WP-Nonce', nonce);
                }
            }
        }).done((function (result) {
            box.close();
            console.log("RES2");
            console.log(result);
            openNotes();
        })).fail((function (error) {
            console.warn(error);
        })).always((function () {
            $item.removeClass("loading");
            $button.prop('disabled', false);
        }));
    }));



    $('.textarea-chooser').on('click', function (event) {
        event.preventDefault();

        console.log("textarea-chooser Click")
        var item = $(this);
        var url = item.data('url');
        var fieldid = item.data('fieldid');
        var texts;

        $.ajax({
                type: 'GET',
                url: url,
                beforeSend: function (xhr) {
                    item.addClass('loading');
                    if (nonce && nonce.length) {
                        xhr.setRequestHeader('X-WP-Nonce', nonce);
                    }
                }
            })
            .done(function (result) {
                if (result.length) {
                    texts = result;
                    initButton();
                } else {
                    return false;
                }
            })
            .fail(function (result) {
                console.warn(result);
            })
            .always(function () {
                item.removeClass('loading');
            });

        function initButton() {
            var textHtml = "";

            $.each(texts, function (i, el) {
                textHtml += '<div class="form-check">';
                textHtml += '<input class="form-check-input" type="radio" name="textblocks" id="radio' + el.id + '" value="' + el.id + '" checked>';
                textHtml += '<label class="form-check-label" for="radio' + el.id + '">' + el.text + '</label>';
                textHtml += '</div>';
            });

            $.confirm({
                columnClass: 'large',
                title: overlay.data('fc-title'),
                content: overlay.data('fc-content')
                        + '<form action="" class="textblocks-form mt-1">' + textHtml + '</form>',
                buttons: {
                    cancel: {
                        text: overlay.data('fc-no'),
                        btnClass: 'mxm_button btn btn-link'
                    },
                    confirm: {
                        text: overlay.data('fc-yes'),
                        btnClass: 'mxm_button btn btn-danger',
                           action: function (confirmBtn) {
                               var checked = this.$content.find('[name="textblocks"]:checked').val();
                               if (!checked) {
                                   $.alert('Eingabe ungültig');
                                   return false;
                                }

                                var checkedText = this.$content.find('[name="textblocks"]:checked + label').text();
                                $('[data-fieldid="' + fieldid + '"]').val(checked);
                                $('#' + fieldid + ' textarea').val(checkedText);
                           },
                           onContentReady: function () {
                               var jc = this;
                               this.$content.find('form').on('submit', function (e) {
                                   // if the user submits the form by pressing enter in the field.
                                   e.preventDefault();
                                   jc.$$formSubmit.trigger('click');
                               });
                           }
                    }
                }
            });
        }
    });
});